var Isotope = require('isotope-layout');
export const specialistes = {
    init: function () {
    if($('.bk-experts-list .list-grid').length) {
        var iso = new Isotope(".bk-experts-list .main-list .list-grid", {
          itemSelector: ".bk-experts-list .main-list .list-grid .list-card",
          hiddenStyle: {
            opacity: 0,
          },
          visibleStyle: {
            opacity: 1,
          },
          layoutMode: "fitRows",
          fitRows: {
            equalheight: true,
          },
        });
        //$('.filter-button-group li[data-filter=".quebec"]').addClass('active');
        // filter items on button click
        $('.filter-button-group').on( 'click', 'li', function() {
            var filterValue = $(this).attr('data-filter');
            iso.arrange({ filter: filterValue });
            $('.filter-button-group li').removeClass('active');
            $(this).addClass('active');
        });
        $('.filter-select-group-experts').on('change', function(e) {
            const filterValue = $(this).find(":selected").val();
            
            iso.arrange({ filter: filterValue });
        })
    }
    }
};